export default __webpack_public_path__ + "static/media/SAS Alert Tone 8.3401c4c1.wav";